import script from "./scanner.vue?vue&type=script&setup=true&lang=js"
export * from "./scanner.vue?vue&type=script&setup=true&lang=js"

import "./scanner.vue?vue&type=style&index=0&id=13590166&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13590166"]])

export default __exports__